module.exports = __webpack_public_path__ + "img/cp2-3.f2df9fe2.jpg";